// extracted by mini-css-extract-plugin
module.exports = {"colors":"JCy5hOv","sidePadding":"_2xG5SaQ"};
    if(module.hot) {
      // 1545369434786
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  